import Section from '@repo/ui/src/components/Section';
import LearnCard from '@repo/ui/src/components/Cards/LearnCard';
import { AmplienceButtonProps, MediaType, ToutContentProps } from '@repo/ui/src/types';

interface Props {
  cards: Array<{
    backgroundImage: MediaType;
    toutContent: ToutContentProps;
    buttons: Array<AmplienceButtonProps>;
  }>;
  backgroundColor: string;
  backgroundTexture: boolean;
  _testID: string;
}

const ThreeCardStack = ({ cards, backgroundColor, backgroundTexture, _testID }: Props) => {
  if (!cards) return null;

  return (
    <Section
      dark={backgroundColor === 'Dark'}
      black={backgroundColor === 'Black'}
      white={backgroundColor === 'White'}
      texture={backgroundTexture}
      gutterX
      gutterY
    >
      <div className="tw-grid tw-justify-center">
        <ul
          className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 [@media(min-width:1200px)]:tw-grid-cols-3 tw-gap-5 tw-max-w-body tw-w-full lg:tw-px-20 tw-list-none tw-p-0"
          data-test-id={`callout_slider_${_testID}`}
        >
          {cards?.map((card, i) => (
            <li key={i} className="tw-m-0 tw-p-0">
              <LearnCard
                title={card.toutContent?.heading}
                backgroundImage={card.backgroundImage}
                buttons={card.buttons}
                description={card.toutContent?.description}
                backgroundColor={backgroundColor}
                learnShopGrid
              />
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
};

export default ThreeCardStack;
